/* global DetectUserAgent */
import { useState, useMemo, useContext } from "react";

import { getTrackingId } from "tracking/jibjab/tracking";
import { InAppBrowserIntentContext } from "contexts/InAppBrowserIntentContext";

const useInAppBrowserIntent = (browseInputRef, onIntentRedirect) => {
  const intentTriggeredRef = useContext(InAppBrowserIntentContext);
  const [wasBrowsePhotoClicked, setWasBrowsePhotoClicked] = useState(
    intentTriggeredRef ? intentTriggeredRef.current : false,
  );

  const isFB4AndroidOrInstagram4Android = DetectUserAgent.isFB4Android() || DetectUserAgent.isInstagram4Android();
  const source = DetectUserAgent.isFB4Android() ? "facebook" : "instagram";

  const intentUrl = useMemo(() => {
    if (!isFB4AndroidOrInstagram4Android) {
      return null;
    }

    const trackingId = getTrackingId();
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("landing_default_browser", source);
    currentUrl.searchParams.set("tracking_id", trackingId);

    const url = currentUrl.toString();

    return `${url.replace(/^https?:\/\//, "intent://")}#Intent;scheme=https;S.browser_fallback_url=${encodeURIComponent(
      url,
    )};end;`;
  }, [isFB4AndroidOrInstagram4Android]);

  const onFileSelected = () => {
    if (intentTriggeredRef) intentTriggeredRef.current = false;
  };

  const handleInAppBrowserIntent = () => {
    if (!isFB4AndroidOrInstagram4Android) return false;

    if (intentTriggeredRef && intentTriggeredRef.current) {
      setWasBrowsePhotoClicked(true);

      if (intentUrl) {
        if (onIntentRedirect) onIntentRedirect(source);
        window.location.assign(intentUrl);
      }

      return true;
    }

    if (intentTriggeredRef) intentTriggeredRef.current = true;

    if (browseInputRef.current) {
      browseInputRef.current.addEventListener("change", onFileSelected, { once: true });
    }

    return false;
  };

  return { handleInAppBrowserIntent, wasBrowsePhotoClicked, intentUrl, isFB4AndroidOrInstagram4Android, source };
};

export default useInAppBrowserIntent;
